import * as React from "react";
import { Asset, Hotspot, TourData } from "../../../../Types";
import { UseDownloadAsset } from "../../../../api/calls/Queries";
import { Html } from "@react-three/drei";
import IconSound from "../../../Icons/IconSound";
import { Pause } from "../../../Icons/Player";
import { useVolumeStore } from "../../../../state management/zustand/common-stores";

const ViewerAudio = (props: {
  audioList: Asset[] | undefined;
  tourID: number;
  audio: Hotspot;
  tourData: TourData;
  currentSceneID: number;
  zoom: number;
}) => {
  const { data, isLoading } = UseDownloadAsset(
    props.audioList?.find((one) => one.assetId === props.audio.target)
      ?.assetKeyFull
  );

  const currentAudio: Asset | undefined = React.useMemo(() => {
    return props.audioList?.find((one) => one.assetId === props.audio.target);
  }, [props.audioList, props.audio]);

  const [percentage, setPercentage] = React.useState<number>(0);
  const [dur, setDur] = React.useState<number>(0);

  const [status, setStatus] = React.useState<string>("init");

  const { volume } = useVolumeStore();

  const ref = React.useRef<HTMLAudioElement>(null);

  console.debug(ref.current);

  React.useEffect(() => {
    if (ref.current) ref.current.volume = volume;
  }, [volume]);

  if (props.audioList)
    return (
      <>
        <Html center>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              opacity: ref.current === null ? 0.5 : 1,
              cursor: ref.current === null ? "wait" : "pointer",
            }}
            tooltip-text={props.audio.title || "Audio senza titlo"}
            className="viewer-exp-icon"
            onClick={() => {
              if (ref.current) {
                if (!ref.current.paused) {
                  ref.current.pause();
                } else {
                  ref.current.play();
                }
              }
            }}
          >
            {ref.current === null || ref.current.paused ? (
              <IconSound
                height="3rem"
                width="3rem"
                stroke="#282828"
                strokeWidth="45px"
                fill="#fff"
                style={{
                  opacity: ((props.zoom - 15) * 100) / 76 <= 30 ? 0.3 : 1,
                }}
              />
            ) : (
              <Pause
                height="3rem"
                width="3rem"
                stroke="#282828"
                fill="#fff"
                style={{
                  opacity: ((props.zoom - 15) * 100) / 76 <= 30 ? 0.3 : 1,
                }}
              />
            )}
            {data && (
              <audio
                ref={ref}
                src={data}
                onLoadedData={(e) => {
                  setStatus("loaded");
                  setDur(e.currentTarget.duration);
                }}
                onPlay={(e) => {
                  setStatus("played");
                }}
                onEnded={(e) => {
                  setStatus("ended");
                }}
                onPause={(e) => {
                  if (e.currentTarget.currentTime !== 0) setStatus("paused");
                }}
                onTimeUpdate={(e) => {
                  setPercentage(
                    e.currentTarget.currentTime / e.currentTarget.duration
                  );
                }}
              />
            )}
            {/* Potrebbe non servire */}
            {/* {status !== "loaded" && status !== "init" && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 5,
                  fontWeight: "600",
                  color: "#fff",
                }}
              >
                <button
                  style={smallBtn}
                  onClick={() => {
                    if (ref.current) {
                      ref.current.pause();
                      ref.current.currentTime = 0;
                      setStatus("loaded");
                    }
                  }}
                >
                  <Stop></Stop>
                </button>

                <button
                  style={smallBtn}
                  onClick={() => {
                    if (ref.current) {
                      if (status === "played") {
                        ref.current.pause();
                      } else if (status === "paused") {
                        ref.current.play();
                      } else if (status === "ended") {
                        ref.current.currentTime = 0;
                        ref.current.play();
                      }
                    }
                  }}
                >
                  {status === "ended" ? (
                    <Replay />
                  ) : status === "paused" ? (
                    <Play></Play>
                  ) : (
                    <Pause></Pause>
                  )}
                </button>
                <div
                  className="progressbg"
                  style={{
                    backgroundColor: "#fff8",
                    height: 5,
                    width: 60,
                    position: "relative",
                  }}
                >
                  <div
                    className="progress"
                    style={{
                      background: "#0C4A6E",
                      height: "100%",
                      width: `${percentage * 100}%`,
                    }}
                  ></div>
                </div>
                {secondsParser(dur)}
              </div>
            )} */}
          </div>
        </Html>
      </>
    );
};

export default ViewerAudio;
